.fp-horizontal-spacing.-items-center
  .fp-horizontal-spacing--column(data-test='footer-price')
    ExclusivePriceVue(v-if='exclusiveUi.auctionLot' :pricing='exclusiveUi.auctionLot.currentPrice' xl vertical)
    ExclusivePriceVue(v-else :pricing='exclusiveUi.pricing' xl vertical)
  .fp-horizontal-spacing--column
    FairplayerButtonVue(v-if='isAuthenticated' :icon='buyButtonIcon' :text='t(`marketplace.exclusiveDetail.${buyButtonKey}`)' :loading='isBuying' :disabled='buyButtonDisabled' @click='buy' data-test='exclusive-page.buy')
    LoginVue(v-else :icon='buyButtonIcon' :translate-key='`marketplace.exclusiveDetail.${buyButtonKey}`')
